if (!customElements.get("cheeky-review-preview")) {
  class CheekyReviewPreview extends HTMLElement {
    constructor() {
      super();
      this.isOpen = true;
      this.reviews = [];
    }

    async connectedCallback() {
      // Initial render with loading state
      this.innerHTML = `
        <div class="dropdown-menu reviews-preview active">
          <div class="dropdown-title">
            <span>Review Highlights</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1757_930)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 8C0.5 3.858 3.858 0.5 8 0.5C12.142 0.5 15.5 3.858 15.5 8C15.5 12.142 12.142 15.5 8 15.5C3.858 15.5 0.5 12.142 0.5 8ZM6.71867 11.2733C6.73367 11.6137 6.94233 11.9033 7.27967 11.9527C7.465 11.9797 7.703 12 8 12C8.297 12 8.535 11.9797 8.72033 11.9527C9.05767 11.9033 9.26633 11.6137 9.28133 11.2733C9.298 10.8887 9.31733 10.2703 9.327 9.327C10.2703 9.31733 10.8887 9.29833 11.2733 9.28133C11.6137 9.26633 11.9033 9.05767 11.9527 8.72033C11.9797 8.535 12 8.297 12 8C12 7.703 11.9797 7.465 11.9527 7.27967C11.9033 6.94233 11.6137 6.73367 11.2733 6.71867C10.8887 6.702 10.2703 6.68267 9.327 6.673C9.31733 5.72967 9.29833 5.11133 9.28133 4.72667C9.26633 4.38633 9.05767 4.09667 8.72033 4.04733C8.48168 4.01423 8.24094 3.99841 8 4C7.703 4 7.465 4.02033 7.27967 4.04733C6.94233 4.09667 6.73367 4.38633 6.71867 4.72667C6.702 5.11133 6.68267 5.72967 6.673 6.673C5.72967 6.68267 5.11133 6.70167 4.72667 6.71867C4.38633 6.73367 4.09667 6.94233 4.04733 7.27967C4.01423 7.51833 3.99841 7.75906 4 8C4 8.297 4.02033 8.535 4.04733 8.72033C4.09667 9.05767 4.38633 9.26633 4.72667 9.28133C5.11133 9.298 5.72967 9.31733 6.673 9.327C6.68267 10.2703 6.70167 10.8887 6.71867 11.2733Z" fill="#1E2815"/>
              </g>
              <defs>
              <clipPath id="clip0_1757_930">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <div class="dropdown-content" style="max-height: none;">
            <div class="reviews-container">
              <div class="loading">Loading reviews...</div>
            </div>
          </div>
        </div>
      `;

      // Add rotated class to icon initially
      const icon = this.querySelector(".dropdown-title svg");
      icon.classList.add("rotated");

      this.querySelector(".dropdown-title").addEventListener("click", () =>
        this.toggle()
      );
      // Get product data from our dropdown container specifically
      const container = this.closest(".dropdown-list-container");
      const productID = container?.dataset.productId;
      if (productID) {
        await this.fetchReviews(productID);
      }
    }

    async fetchReviews(external_id) {
      try {
        // Public Junip store key (same one the on-site widget uses); read from the
        // theme's junip-store-key element so it stays in sync if it's ever rotated.
        const storeKey =
          document.querySelector(".junip-store-key")?.dataset?.storeKey ||
          "5uuAuf4xUBFQWHuGopMeiJy3";

        // Junip Display API: reviews for this product, highest-rated first.
        // The Shopify product id is Junip's remote_id. Auth via store-key header
        // (identical request to Junip's own on-site review widget).
        const response = await fetch(
          `https://apid.juniphq.com/en/v2/products/remote/${external_id}/reviews?page_size=30&sort_field=rating&sort_order=desc`,
          { headers: { "junip-store-key": storeKey } }
        );
        const data = await response.json();
        const allReviews = (data && data.data) || [];

        // Accessories (tray / bags) have shorter reviews, so use a looser length gate.
        const accessoryHandles = ["soap-tray", "soap-bags", "shower-tray"];
        const productHandle =
          (allReviews[0] &&
            allReviews[0].product &&
            allReviews[0].product.remote_handle) ||
          "";
        const isAccessory = accessoryHandles.some(
          (h) => productHandle.includes(h) || window.location.href.includes(h)
        );

        let lastReviewAuthor = "";
        const reviews = allReviews
          .map((review) => {
            const customer = review.customer || {};
            return {
              rating: review.rating,
              title: (review.title || "").trim(),
              body: (review.body || "").trim(),
              author: [customer.first_name, customer.last_name]
                .filter(Boolean)
                .join(" ")
                .trim(),
              verifiedBuyer: review.verified_buyer === true,
            };
          })
          .filter((review) => {
            if (review.rating !== 5) return false;
            if (isAccessory) {
              if (review.body.length > 15) {
                lastReviewAuthor = review.author;
                return true;
              }
              return false;
            }
            if (review.body.length > 100 && review.author !== lastReviewAuthor) {
              lastReviewAuthor = review.author;
              return true;
            }
            return false;
          })
          .slice(0, 3);

        if (reviews.length > 0) {
          this.renderReviews(reviews);
        } else {
          this.hideReviewSection();
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        this.hideReviewSection();
      }
    }



    renderReviews(reviews) {
      const reviewsHtml = reviews
        .map(
          (review) => `
        <div class="review-item">
          <div class="review-stars">
            <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
          </div>
          <p class="review-title">${review.title ? `${review.title} - ` : ""}${
            review.author
          }</p>
          <p class="review-text" data-full-review="${this.escapeHtml(
            review.body
          )}">
            ${this.truncateText(review.body, 150)}
            ${
              review.body.length > 150
                ? '<span class="continue-reading">Continue Reading</span>'
                : ""
            }
          </p>
        </div>
      `
        )
        .join("");

      const container = this.querySelector(".reviews-container");
      container.innerHTML = `
        ${reviewsHtml}
        ${
          window.location.pathname === "/"
            ? ""
            : '<a href="#all-reviews" class="button reviews-button">Read More Reviews</a>'
        }
      `;

      // Add click handlers for continue reading buttons
      this.querySelectorAll(".continue-reading").forEach((button) => {
        button.addEventListener("click", (e) => {
          e.stopPropagation();
          const reviewText = e.target.closest(".review-text");
          const fullReview = reviewText.getAttribute("data-full-review");
          reviewText.innerHTML = fullReview;
        });
      });
    }

    hideReviewSection() {
      this.style.display = "none";
    }

    truncateText(text, limit) {
      if (text.length <= limit) return this.escapeHtml(text);
      return this.escapeHtml(text.slice(0, limit) + "...");
    }

    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    toggle() {
      this.isOpen = !this.isOpen;
      const content = this.querySelector(".dropdown-content");
      const icon = this.querySelector(".dropdown-title svg");
      const reviewsPreview = this.querySelector(".reviews-preview");

      content.style.maxHeight = this.isOpen ? `${content.scrollHeight}px` : "0";
      icon.classList.toggle("rotated", this.isOpen);
      reviewsPreview.classList.toggle("active", this.isOpen);
    }
  }

  customElements.define("cheeky-review-preview", CheekyReviewPreview);

  class CheekyDropdown extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      const title = this.getAttribute("title");
      this.innerHTML = `
        <div class="dropdown-menu">
          <div class="dropdown-title">
            <span>${title}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1757_930)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 8C0.5 3.858 3.858 0.5 8 0.5C12.142 0.5 15.5 3.858 15.5 8C15.5 12.142 12.142 15.5 8 15.5C3.858 15.5 0.5 12.142 0.5 8ZM6.71867 11.2733C6.73367 11.6137 6.94233 11.9033 7.27967 11.9527C7.465 11.9797 7.703 12 8 12C8.297 12 8.535 11.9797 8.72033 11.9527C9.05767 11.9033 9.26633 11.6137 9.28133 11.2733C9.298 10.8887 9.31733 10.2703 9.327 9.327C10.2703 9.31733 10.8887 9.29833 11.2733 9.28133C11.6137 9.26633 11.9033 9.05767 11.9527 8.72033C11.9797 8.535 12 8.297 12 8C12 7.703 11.9797 7.465 11.9527 7.27967C11.9033 6.94233 11.6137 6.73367 11.2733 6.71867C10.8887 6.702 10.2703 6.68267 9.327 6.673C9.31733 5.72967 9.29833 5.11133 9.28133 4.72667C9.26633 4.38633 9.05767 4.09667 8.72033 4.04733C8.48168 4.01423 8.24094 3.99841 8 4C7.703 4 7.465 4.02033 7.27967 4.04733C6.94233 4.09667 6.73367 4.38633 6.71867 4.72667C6.702 5.11133 6.68267 5.72967 6.673 6.673C5.72967 6.68267 5.11133 6.70167 4.72667 6.71867C4.38633 6.73367 4.09667 6.94233 4.04733 7.27967C4.01423 7.51833 3.99841 7.75906 4 8C4 8.297 4.02033 8.535 4.04733 8.72033C4.09667 9.05767 4.38633 9.26633 4.72667 9.28133C5.11133 9.298 5.72967 9.31733 6.673 9.327C6.68267 10.2703 6.70167 10.8887 6.71867 11.2733Z" fill="#1E2815"/>
              </g>
              <defs>
              <clipPath id="clip0_1757_930">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <div class="dropdown-content">
            ${this.innerHTML}
          </div>
        </div>
      `;

      this.querySelector(".dropdown-title").addEventListener("click", () =>
        this.toggle()
      );
    }

    toggle() {
      this.isOpen = !this.isOpen;
      const content = this.querySelector(".dropdown-content");
      const icon = this.querySelector(".dropdown-title svg");

      content.style.maxHeight = this.isOpen ? `${content.scrollHeight}px` : "0";
      icon.classList.toggle("rotated", this.isOpen);
    }
  }

  customElements.define("cheeky-dropdown", CheekyDropdown);
}
